'use client'

import Button from 'shared/timber/v1/Button'
import styles from './idle-session-page.module.scss'
import { useRouter, useSearchParams } from 'next/navigation'
import Icon from 'shared/timber/v1/Icon'
import { isEmbedPortalPath } from 'shared/utils/auth/embed'

export default function IdleSessionPage() {
  const router = useRouter()
  const params = useSearchParams()

  const redirectTo = params.get('redirect-to')?.toString() || '/projects'

  // "Go Home" points at /projects, which inside a provider's iframe would load
  // the whole app, navigation included, into their page
  const showHome = !isEmbedPortalPath(redirectTo)

  const goHome = () => router.replace('/projects')

  const goBack = () => {
    router.replace(redirectTo)
  }

  return (
    <main className={styles.Page}>
      <article className={styles.PageContent}>
        <Icon size="2xl" icon="clock_stopwatch" background="success" />

        <h1>Session Saved</h1>
        <h2>You have been inactive for too long</h2>

        <p>
          You've been inactive for a while, but don't worry—we've kept
          everything safe. Your work is still here, just as you left it.
          Whenever you're ready, you can pick up right where you left off. If
          you had multiple tabs open, we've saved your progress across all of
          them.
        </p>

        <footer>
          {showHome && (
            <Button appearance="secondary" onClick={goHome} fullWidth>
              Go Home
            </Button>
          )}
          <Button appearance="primary" onClick={goBack} fullWidth>
            Continue Working
          </Button>
        </footer>
      </article>
    </main>
  )
}
